import Navigation from '@/components/navigation/Navigation'
import UserProfile from '@/components/user/UserProfile'
import AccountInformation from '@/components/user/profile/AccountInformation'
import AccountInformationInformation from '@/components/user/profile/accountinformation/Information'
import AccountInformationNameForm from '@/components/user/profile/accountinformation/NameForm'
import AccountInformationEmailForm from '@/components/user/profile/accountinformation/EmailForm'
import AccountInformationPasswordForm from '@/components/user/profile/accountinformation/PasswordForm'
import AccountInformationPictureForm from '@/components/user/profile/accountinformation/PictureForm'
import Notifications from '@/components/user/profile/Notifications'
import Organizations from '@/components/user/profile/Organizations'
import UserProfileStaff from '@/components/user/profile/Staff'
import UserProfileStaffStaff from '@/components/user/profile/staff/StaffStaff'
import UserProfileStaffStaffForm from '@/components/user/profile/staff/StaffStaffForm'
import UserProfileStaffInvitations from '@/components/user/profile/staff/StaffInvitations'
import UserProfileStaffInvitationSendForm from '@/components/user/profile/staff/StaffInvitationSendForm'
import UserProfileSubscriptions from '@/components/user/profile/Subscriptions'
import UserProfileSubscriptionsSubscriptions from '@/components/user/profile/subscriptions/Subscriptions'
import UserProfileSubscriptionsSubscriptionView from '@/components/user/profile/subscriptions/SubscriptionView'
import UserProfileSubscriptionsSubscriptionTransactionView from '@/components/user/profile/subscriptions/SubscriptionTransactionView'
import UserProfileSubscriptionsResume from '@/components/user/profile/subscriptions/Resume'
import UserProfileBudget from '@/components/user/profile/Budget'
import UserProfileBudgetBudget from '@/components/user/profile/subscriptions/Budget'
import UserProfileBudgetAccountMovements from '@/components/user/profile/subscriptions/AccountMovements'
import UserProfileBudgetPaymentMethods from '@/components/user/profile/subscriptions/PaymentMethods'
import Synchronization from '@/components/user/profile/Synchronization'
import InvitationAccept from '@/components/user/invitations/InvitationAccept'
import AppShell from '@/components/shell/AppShell'

export default [
	{
		path: '/:user_uid',
		components: {
			default: AppShell
		},
		props: {
			default: true
		},
		children: [
			{
				path: 'invitations/:invitation_id/accept',
				name: 'InvitationAccept',
				meta: {
					requiredAuth: true
				},
				components: {
					default: InvitationAccept,
					menu: Navigation
				},
				props: { default: true, sidebar: true }
			},
			{
				path: 'profile',
				name: 'UserProfile',
				meta: {
					requiredAuth: true
				},
				components: {
					default: UserProfile,
					menu: Navigation
				},
				children: [
					{
						path: 'account',
						redirect: 'account/information',
						name: 'UserProfileAccount',
						component: AccountInformation,
						children: [
							{
								path: 'information',
								name: 'UserProfileAccountInformation',
								component: AccountInformationInformation,
								props: true
							},
							{
								path: 'name',
								name: 'UserProfileAccountName',
								component: AccountInformationNameForm,
								props: true
							},
							{
								path: 'email',
								name: 'UserProfileAccountEmail',
								component: AccountInformationEmailForm,
								props: true
							},
							{
								path: 'password',
								name: 'UserProfileAccountPassword',
								component: AccountInformationPasswordForm,
								props: true
							},
							{
								path: 'picture',
								name: 'UserProfileAccountPicture',
								component: AccountInformationPictureForm,
								props: true
							}
						],
						props: true
					},
					/*{
						path: 'payment-methods',
						name: 'UserProfilePaymentMethods',
						component: UserProfilePaymentMethods,
						props: true
					},
					{
						path: 'current-plan',
						name: 'UserProfileCurrentPlan',
						component: UserProfileCurrentPlan,
						props: true
					},
					{
						path: 'pro-plan',
						name: 'UserProfileProPlan',
						component: UserProfileProPlan,
						props: true
					},*/
					{
						path: 'subscriptions',
						redirect: 'subscriptions/all',
						name: 'UserProfileSubscriptions',
						component: UserProfileSubscriptions,
						children: [
							{
								path: 'all',
								name: 'UserProfileSubscriptionsSubscriptions',
								component: UserProfileSubscriptionsSubscriptions,
								props: true
							},
							{
								path: 'resume',
								name: 'UserProfileSubscriptionsResume',
								component: UserProfileSubscriptionsResume,
								props: true
							},
						],
						props: true
					},
					{
						path: 'subscriptions/:subscription_id',
						name: 'UserProfileSubscriptionsSubscriptionView',
						component: UserProfileSubscriptionsSubscriptionView,
						props: (route) => ({
							user_uid: route.params.user_uid,
							subscription_id: route.params.subscription_id,
							subscription_data: route.params.subscription_data
						})
					},
					{
						path: 'subscriptions/:subscription_id/transaction/:transaction_id',
						name: 'UserProfileSubscriptionsSubscriptionTransactionView',
						component: UserProfileSubscriptionsSubscriptionTransactionView,
						props: (route) => ({
							user_uid: route.params.user_uid,
							subscription_id: route.params.subscription_id,
							subscription_data: route.params.subscription_data,
							transaction_id: route.params.transaction_id,
							transaction_data: route.params.transaction_data
						})
					},
					// {
					// 	path: 'budget',
					// 	redirect: 'budget/details',
					// 	name: 'UserProfileBudget',
					// 	component: UserProfileBudget,
					// 	children: [
					// 		{
					// 			path: 'details',
					// 			name: 'UserProfileBudgetBudget',
					// 			component: UserProfileBudgetBudget,
					// 			props: true
					// 		},
					// 		{
					// 			path: 'account-movements',
					// 			name: 'UserProfileBudgetAccountMovements',
					// 			component: UserProfileBudgetAccountMovements,
					// 			props: true
					// 		},
					// 		{
					// 			path: 'payment-methods',
					// 			name: 'UserProfileBudgetPaymentMethods',
					// 			component: UserProfileBudgetPaymentMethods,
					// 			props: true
					// 		}
					// 	],
					// 	props: true
					// },
					{
						path: 'notifications',
						name: 'UserProfileNotifications',
						component: Notifications,
						props: true
					},
					{
						path: 'organizations',
						name: 'UserProfileOrganizations',
						component: Organizations,
						props: true
					},
					{
						path: 'staff',
						redirect: 'staff/staff',
						name: 'UserProfileStaff',
						component: UserProfileStaff,
						props: true,
						children: [
							{
								path: 'staff',
								name: 'UserProfileStaffStaff',
								component: UserProfileStaffStaff,
								props: true,
								children: [
									{
										path: ':staff_id',
										name: 'UserProfileStaffStaffForm',
										component: UserProfileStaffStaffForm,
										props: (route) => ({
											user_uid: route.params.user_uid,
											staff_id: route.params.staff_id,
											data: route.params.data
										})
									}
								]
							},
							{
								path: 'invitations',
								name: 'UserProfileStaffInvitations',
								component: UserProfileStaffInvitations,
								props: true,
								children: [
									{
										path: 'send',
										name: 'UserProfileStaffInvitationSendForm',
										component: UserProfileStaffInvitationSendForm,
										props: true
									}
								]
							}
						]
					},
					{
						path: 'synchronization',
						name: 'UserProfileSynchronization',
						component: Synchronization,
						props: true
					}
				]
			}
		]
	}
]



// WEBPACK FOOTER //
// ./src/router/modules/account.js